/** Audit log API client (T62). Real read endpoint /api/v1/audit-logs. */
import { apiClient } from "./client";
import { MOCKS_ENABLED } from "./mock/registry";
import { mockAudit } from "./mock/audit";
import type { AuditListFilter, AuditLogEntry } from "../types/audit";
import type { PageResponse } from "../types/patient";

const realClient = {
  list(
    filter: AuditListFilter | undefined,
    pageable: { page?: number; size?: number }
  ): Promise<PageResponse<AuditLogEntry>> {
    const params: Record<string, string | number> = {};
    if (filter?.q) params.q = filter.q;
    if (filter?.action) params.action = filter.action;
    if (filter?.entityType) params.entityType = filter.entityType;
    if (filter?.fromDate) params.fromDate = filter.fromDate;
    if (filter?.toDate) params.toDate = filter.toDate;
    if (pageable.page != null) params.page = pageable.page;
    if (pageable.size != null) params.size = pageable.size;
    return apiClient
      .get<PageResponse<AuditLogEntry>>("/v1/audit-logs", { params })
      .then((r) => r.data);
  },
};

export const auditApi = MOCKS_ENABLED ? mockAudit : realClient;

export const auditQueryKeys = {
  all: ["audit"] as const,
  list: (filter: unknown, page: number) =>
    ["audit", "list", filter, page] as const,
};
